import OnScreen from 'onscreen/dist/on-screen.es6';

export default {
  init() {
    // JavaScript to be fired on all pages

    const os = new OnScreen({
        tolerance: 0,
        debounce: 1,
    });

    os.on('enter', '.os', (element) => {
        element.classList.add('os-in');
    });

    // make items scrollreveal items appear
    setTimeout(function(){
        window.scrollTo(0,1);
    }, 200);



    const tilt = $('[data-tilt]').tilt(); // eslint-disable-line

    if ($(window).width() < 1200) {
        setTimeout(function() {
            tilt.tilt.destroy.call(tilt);
        }, 1000);
    }


    // toggle navigation
    $('.js-toggle-nav').on('click', function() {
        navExpandPadding()

        var htmlEl = $('html');
        var bodyEl = $('body');
        var text;
        var offset = $('.c-site-header').outerHeight();


        if(bodyEl.hasClass('search-open')) {
            bodyEl.removeClass('search-open');
            const closedText = $('.js-toggle-search-text').data('closed-text');
            $('.js-toggle-search-text').html(closedText);
        }

        if (bodyEl.hasClass('nav-open')) {
            htmlEl.removeClass('overflow-hidden');
            bodyEl.removeClass('overflow-hidden nav-open');
            bodyEl.css('padding-top', '');
            $('.c-site-nav__item--has-children').removeClass('sub-menu-expanded');

            text = $('.js-toggle-nav-text').data('closed-text');
            $('.js-toggle-nav-text').html(text);
        } else {
            htmlEl.addClass('overflow-hidden');
            bodyEl.addClass('overflow-hidden nav-open');
            bodyEl.css('padding-top', offset + 'px');

            text = $('.js-toggle-nav-text').data('open-text');
            $('.js-toggle-nav-text').html(text);
        }
    });


    // magnific popup toggle video
    $(document).ready(function() {
        $('.mfp-video').magnificPopup({
            type:'iframe',
            removalDelay: 300,
            mainClass: 'mfp-anim',
        });
    });


    $(window).resize(function() {
        navExpandPadding();
    });


    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 90) {
            $('.c-site-header').addClass('is-fixed');
        } else {
            $('.c-site-header').removeClass('is-fixed');
        }
    });


    initMap();


    // filtering
    if ($('[data-filter-container]').length) {
        var filterValue;

        const $grid = $('[data-filter-container]').imagesLoaded(function() {
            $grid.isotope({
                //itemSelector: '.c-tile',
                layoutMode: 'fitRows',
                percentPosition: true,
                stagger: 30,
                initLayout: false,
            });
        });

        // init layout
        setTimeout(function() {
            $grid.isotope('layout');
        }, 250);


        // fix buggy portrait tablet to landscape tablet isotopin
        $(window).resize(function () {
            waitForFinalEvent(function(){
                $grid.isotope('layout');
            }, 1000, "isotope-layout");
        });


        $('.c-sort-bar').on( 'click', '[data-filter]', function() {
            $('[data-filter]').each(function() {
                $(this).removeClass('is-toggled');
            });

            if (filterValue == $(this).attr('data-filter')) {
                filterValue = '*';
            } else {
                filterValue = $(this).attr('data-filter');
                $(this).addClass('is-toggled');
            }

            $grid.isotope({ filter: filterValue });
        });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

function navExpandPadding() { // eslint-disable-line
    if ($(window).width() > 1200) {
        var navTopPadding = $('.c-site-header').outerHeight();
        $('.c-site-expanded-nav').css('padding-top', navTopPadding + 36 + 'px');
    } else {
        $('.c-site-expanded-nav').css('padding-top', '');
    }
}

function initMap() {

    // exit if no map element
    if ($('.js-map-wrap').length == 0) {
        return;
    }

    var mapWrap    = $('.js-map-wrap'),
        latitude   = mapWrap.data('latitude'),
        longitude  = mapWrap.data('longitude'),
        markerLat  = latitude,
        markerLong = longitude;

    // offset map to the left on larger screens
    if ($(window).width() > 1439) {
      longitude = longitude + 0.025;
    }

    var map = new google.maps.Map(document.getElementById('map'), { // eslint-disable-line
        zoom: 14,
        disableDefaultUI: true,
        center: {lat: latitude, lng: longitude},
        styles: [{featureType:"all",elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#000000"},{lightness:40}]},{featureType:"all",elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#000000"},{lightness:16}]},{featureType:"all",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:17},{weight:1.2}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#000000"},{lightness:20}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#000000"},{lightness:21}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#000000"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#000000"},{lightness:29},{weight:.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#000000"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#000000"},{lightness:16}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#000000"},{lightness:19}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#000000"},{lightness:17}]}], // eslint-disable-line
    });

    var marker = new google.maps.Marker({ // eslint-disable-line
        position: new google.maps.LatLng(markerLat, markerLong), // eslint-disable-line
        map: map,
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js